import { render, staticRenderFns } from "./PieSectionConfigForm.vue?vue&type=template&id=75072fcd&scoped=true&"
import script from "./PieSectionConfigForm.vue?vue&type=script&lang=js&"
export * from "./PieSectionConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75072fcd",
  null
  
)

export default component.exports